/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SupportedLanguage {
    None = 0,
    English = 1,
    Spanish = 2,
    French = 4,
    Armenian = 8,
    Arabic = 16,
    Chinese = 32,
    German = 64,
    Italian = 128,
    Russian = 256,
    Tagalog = 512,
    Vietnamese = 1024,
    Somali = 2048,
}
